module.exports = __webpack_public_path__ + "media/Goodness_of_God_live- Bethel Music_Victory_mp3_75924.5047e11c.mp3";